import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader"
import { ThemedView, ThemedText, ThemedPressable, themeColorSet } from "@app/theme"
import { ScrollView, ImageBackground, Image, Platform, Text } from "react-native"
import ClockIcon from "../../../assets/Icons/ClockIcon"
import Button from "@app/sharedComponents/Button/Button"
import { CaretRight } from "@sharedComponents/Icons/index"
import BottomSheetContainer from '@app/sharedComponents/Bottomsheet/Bottomsheet';
import { useState } from "react"
import HowItWorks from "./components/HowItWorks"
import WhyOpenAcc from "./components/WhyOpenAcc"
import ROUTE from "@app/navigationApp/routes"
import { NativeStackScreenProps } from "@react-navigation/native-stack"
import { PrivateStackParamList } from "@app/navigationApp/types"
import ChatCircleDots from '@app/assets/svg/ChatCircleDots'
import ElevateDocumentIcon from '@app/assets/svg/ElevateDocumentIcon'
import FAQIcon from '@app/assets/svg/FAQIcon'
import { endpoints } from "@app/api/apis"
import axios from "axios"
import { showErrorSheet } from "@app/store/slices/errorSlice"
import { useDispatch } from "react-redux"
import AsyncStorage from "@react-native-async-storage/async-storage"
import { useAppSelector } from "@app/store/hooks"
import { trackEvent } from "@app/utils"


export const bookTransferV2Api = async (payload: { creditId: string }) => {
    const response = await axios.get(endpoints.bookTransferV2 + 'credit/' + payload.creditId);
    return response.data;

}

type ScreenProps = NativeStackScreenProps<PrivateStackParamList, 'ELEVATE_LANDING'>;


const ElevateLanding = ({ navigation }: ScreenProps) => {
    const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
    const [bottomSheetType, setBottomSheetType] = useState<"HOW_IT_WORKS" | "WHY_OPEN_ACC" | "FAQ">("HOW_IT_WORKS");

    const isBFLLoan = useAppSelector(state => state.commonReducer.isBFLLoan);


    const creditId = useAppSelector(state => state?.auth?.userDetails?.linkedCredits[0]?.creditId)
    const [isLoading, setIsLoading] = useState(false)

    const openBottomSheet = (type: "HOW_IT_WORKS" | "WHY_OPEN_ACC" | "FAQ") => {
        setBottomSheetType(type);
        setIsBottomSheetVisible(true);
    };

    const dispatch = useDispatch();

    const closeBottomSheet = () => {
        setIsBottomSheetVisible(false);
    };

    const handleBookTransfer = async () => {
        try {
            setIsLoading(true)
            const response = await bookTransferV2Api({ creditId: creditId });
            const newDspApplicationId = response?.applicationId
            if(newDspApplicationId) {
              await AsyncStorage.setItem('application_id', newDspApplicationId)
            }
            const currentStepId = response?.currentStepId
            trackEvent('DSP_NEW_LOAN_LANDING_PAGE_CHECK_ELIGIBILITY_BUTTON_CLICKED')
            if (Platform.OS === 'web') {
                navigation.navigate(currentStepId)
            } else {
                navigation.reset({
                    index: 1,
                    routes: [{ name: 'HOME' }, { name: currentStepId }],
                })
            }
        } catch (err: any) {
            console.log(err, 'handleBookTransfer');
            dispatch(showErrorSheet({
                isErrorSheetVisible: true,
                errorMessage: err?.data?.message,
                closeOnBackdropPress: true,
                errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
                errorHeading: err?.data?.header,
                showErrorHeading: true,
                btnName: 'Ok, got it!',
            }))
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <>
            <PageHeaders pageName="ElevateLanding" navigation={navigation} />
            <ScrollView style={{ flex: 1, backgroundColor: themeColorSet["bg-surface-emphasis-primary"] }}>
                <ImageBackground
                    style={{ width: "100%", height: 170, alignItems: "center", justifyContent: "center" }}
                    source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/elevate_landing_mesh_bg.png" }}
                >
                    <ThemedView>
                        <ThemedView flexDirection="row" alignItems="baseline">
                            {isBFLLoan ? (
                                <>
                                    <ThemedText mt="3xl" fontWeight="700" fontSize={72} lineHeight={80} color="text-info">9</ThemedText>
                                    <ThemedText style={{ marginLeft: -4 }} variant="b3b" color="text-info">.99%</ThemedText>
                                </>
                            ) : (
                                <>

                                <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/elevate_landing_coin.png" }}
                            style={{ width: 90, height: 90 , left : 0 }} />
                                </>
                            )}
                        </ThemedView>
                        <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/elelvate_bg_coin_left.png" }}
                            style={{ width: 40, height: 60, position: 'absolute' , left : -70 }} />
                        <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/elelvate_bg_coin_right.png" }}
                            style={{ width: 40, height: 30, position: 'absolute' , right : -60 , top : 40 }} />
                    </ThemedView>
                    <ThemedView borderWidth={1} borderColor="border-info" borderRadius="full" bg="bg-fill-emphasis-primary-1" px="md" mt="lg" py="xs">
                        <ThemedText color="text-info" variant="b4s">₹0 Processing fee</ThemedText>
                    </ThemedView>

                </ImageBackground>
                <ThemedText variant="h3s" color="text-primary" textAlign="center" mx="lg" px="lg" mt="lg" >
                    Now get a loan at lower {'\n'}interest rate
                </ThemedText>

                <ThemedView backgroundColor="bg-fill-primary" mx="lg" borderRadius="lg" px='lg' pt="lg" my="xl">
                    <ThemedText variant="b3s" color="text-primary" mb="lg">Exclusive benefits</ThemedText>
                    <ThemedView flexDirection="row" mb="md">
                        <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={32} height={32} borderRadius="full" justifyContent="center" alignItems="center">
                            <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/0.png" }} style={{ width: 16, height: 16 }} />
                        </ThemedView>
                        <ThemedView ml="lg" flex={1} flexWrap="wrap">
                            <ThemedText variant="b4s" color="text-primary">Zero processing fees</ThemedText>
                            <ThemedView flexDirection="row" alignItems="center">
                                <ClockIcon />
                                <ThemedText variant="b4r" color="text-emphasis-secondary"> Limited period offer </ThemedText>
                            </ThemedView>
                        </ThemedView>
                    </ThemedView>
                    <ThemedView flexDirection="row">
                        <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={32} height={32} borderRadius="full" justifyContent="center" alignItems="center">
                            <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/Lightning.png" }} style={{ width: 16, height: 16 }} />
                        </ThemedView>
                        <ThemedView ml="lg" flex={1} flexWrap={Platform.OS !== 'web' ? 'nowrap' : 'wrap'}>
                            <ThemedText variant="b4s" color="text-primary">Lightning fast withdrawals</ThemedText>
                            <ThemedText variant="b4r" color="text-secondary">Get funds in your account instantly upto 5L and within 2 hours for higher amounts</ThemedText>
                        </ThemedView>
                    </ThemedView>
                    <ThemedView flexDirection="row" py="2xl">
                        <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={32} height={32} borderRadius="full" justifyContent="center" alignItems="center">
                            <Image source={{ uri: "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/StackMinus.png" }} style={{ width: 16, height: 16 }} />
                        </ThemedView>
                        <ThemedView ml="lg" flex={1} flexWrap={Platform.OS !== 'web' ? 'nowrap' : 'wrap'}>
                            <ThemedText variant="b4s" color="text-primary">Seamless asset management</ThemedText>
                            <ThemedText variant="b4r" color="text-secondary">Control the collaterals you want to pledge or
                                un-pledge in just a click!</ThemedText>
                        </ThemedView>
                    </ThemedView>
                </ThemedView>

                <ThemedView backgroundColor="bg-surface-primary" borderTopWidth={1} borderBottomWidth={1} borderColor="border-primary" my="lg">
                    <ThemedPressable onPress={() => openBottomSheet('WHY_OPEN_ACC')} px="lg" py="md" flexDirection="row" justifyContent="space-between" alignItems="center" >
                        <ThemedView flexDirection="row" alignItems="center">
                            <ChatCircleDots size={24} />
                            <ThemedText ml="sm" variant="b3m" color="text-primary">Why open a new loan account?</ThemedText>
                        </ThemedView>
                        <CaretRight />
                    </ThemedPressable>
                    <ThemedPressable onPress={() => openBottomSheet('HOW_IT_WORKS')} borderTopWidth={1} borderBottomWidth={1} borderColor="border-primary"
                        px="lg" py="md" flexDirection="row" justifyContent="space-between" alignItems="center">
                        <ThemedView flexDirection="row" alignItems="center">
                            <ElevateDocumentIcon size={24} />
                            <ThemedText ml="sm" variant="b3m" color="text-primary">How it works?</ThemedText>
                        </ThemedView>
                        <CaretRight />
                    </ThemedPressable>
                    <ThemedPressable onPress={() => navigation.navigate(ROUTE.FAQ)} px="lg" py="md" flexDirection="row" justifyContent="space-between" alignItems="center">
                        <ThemedView flexDirection="row" alignItems="center">
                            <FAQIcon size={24} />
                            <ThemedText ml="sm" variant="b3m" color="text-primary">FAQ</ThemedText>
                        </ThemedView>
                        <CaretRight />
                    </ThemedPressable>
                </ThemedView>
            </ScrollView>
            <ThemedView borderTopWidth={1} borderColor="border-primary" p="lg" pt="2xl" backgroundColor="bg-surface-primary">
                <Button buttonLoader={isLoading} label="Check eligibility" handlePress={handleBookTransfer} />
            </ThemedView>
            <BottomSheetContainer
                isVisible={isBottomSheetVisible}
                close={closeBottomSheet}
                showCloseIcon={true}
                closeOnBackdropPress={true}
                borderTopRightRadius={10}
                borderTopLeftRadius={10}
                containerStyle={{ backgroundColor: '#fefefe' }}
            >
                {bottomSheetType === 'HOW_IT_WORKS' && <HowItWorks closeBottomSheet={closeBottomSheet} />}
                {bottomSheetType === 'WHY_OPEN_ACC' && <WhyOpenAcc closeBottomSheet={closeBottomSheet} />}
            </BottomSheetContainer>
        </>

    )
}

export default ElevateLanding